import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../config/context';
import 'leaflet/dist/leaflet.css';
import './Maps.css';
import L from 'leaflet';

import {LayersControl, Map, Marker, Popup, TileLayer, WMSTileLayer, GeoJSON, ZoomControl, ScaleControl} from 'react-leaflet';
import {BingLayer} from 'react-leaflet-bing-v2';
import Center from './Center';
import Legend from './Legend';
import LegendBphtb from './Legend/LegendBphtb';
import LegendPendataan from './Legend/LegendPendataan';
import SearchBrowser from './SearchBox/SearchBrowser';
import Loading from '../../component/Loading';
import Realisasi from './Realisasi';
import PendataanSurveyor from './Pendataan/PendataanSurveyor';
import PendataanKelurahan from './Pendataan/PendataanKelurahan';
import PendataanTarget from './Pendataan/PendataanTarget';
import DrawersBrowser from './Drawers/DrawersBrowser';
import {Drawer, List, ListItem} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import MonografiKelurahan from './Monografi/MonografiKelurahan';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles = makeStyles((theme) => ({
  body: {},
  map: {},
  center: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  legend: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  bphtb: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  pendataan: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  chart: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'center',
  },
  search: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  loading: {
    // position: 'absolute',
    // width: '100%',
    // top: 0,
    // display:'none',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    flexDirection: 'unset',
  },
}));

const MapsBrowser = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [
    {pencarian, checkedPbb, checkedBphtb, checkedPendataan, centroidLatitude, centroidLongitude, zoomKelurahan, zoomBlok, zoomPersil},
    {
      setPencarian,
      setCheckedPbb,
      setCheckedBphtb,
      setCheckedPendataan,
      setCentroidLatitude,
      setCentroidLongitude,
      setZoomKelurahan,
      setZoomBlok,
      setZoomPersil,
    },
  ] = useAppContext();
  const {
    mapRef,
    baseLayerChange,
    zoomEnd,
    dragEnd,
    kelurahanRefGeoJson,
    getKelurahan,
    blokRefGeoJson,
    getBlok,
    persilRefGeoJson,
    getPersil,
    zntRefGeoJson,
    getZnt,
    markerPbbRefGeoJson,
    getMarkerPbb,
    markerBphtbRefGeoJson,
    getMarkerBphtb,
    markerHotelRefGeoJson,
    getMarkerHotel,
    markerRestoranRefGeoJson,
    getMarkerRestoran,
    markerHiburanRefGeoJson,
    getMarkerHiburan,
    markerReklameRefGeoJson,
    getMarkerReklame,
    markerPpjRefGeoJson,
    getMarkerPpj,
    markerParkirRefGeoJson,
    getMarkerParkir,
    markerPatRefGeoJson,
    getMarkerPat,
    markerWaletRefGeoJson,
    getMarkerWalet,
    markerMblbRefGeoJson,
    getMarkerMblb,
    markerPendataanRefGeoJson,
    getMarkerPendataan,
    inputNop,
    setInputNop,
    facebookProgress,
    clearIcon,
    handleKeyPress,
    onClear,
    onSearchNop,
    checked,
    handleDetails,
    monografiKelurahan,
    setMonografiKelurahan,
    handleMonografiKelurahan,
    detailMonografiKelurahan,
    setDetailMonografiKelurahan,
    chartMonografiKelurahan,
    setChartMonografiKelurahan,
    searchNop,
    searchSppt,
    piutangLoading,
    tahunSPPT,
    handleTahunSPPT,
    itemTahunSPPT,
    detailNop,
    detailSppt,
    images,
    streetView,
  } = props;

  //drawer
  const [drawer, setDrawer] = React.useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const cariCoordinat = [latitude, longitude];

  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  const state = {
    lat: centroidLatitude,
    lng: centroidLongitude,
    zoom: zoomKelurahan,
  };

  const {BaseLayer} = LayersControl;
  const bing_key = 'AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L';
  const position = [state.lat, state.lng];

  return (
    <div className={classes.body}>
      <div className={classes.map}>
        <Map
          ref={mapRef}
          className="map"
          center={position}
          zoom={state.zoom}
          zoomControl={false}
          onBaseLayerChange={baseLayerChange}
          onZoomEnd={zoomEnd}
          onDragEnd={dragEnd}>
          <LayersControl position="topright">
            <BaseLayer checked name="Open Street Maps">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://www.openstreetmap.org/" target="blank">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </BaseLayer>
            <BaseLayer name="Google Maps">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
              />
            </BaseLayer>
            <BaseLayer name="Google Satelite">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
              />
            </BaseLayer>
            <BaseLayer name="Bing Maps">
              <BingLayer bingkey={bing_key} />
            </BaseLayer>
            <BaseLayer name="Transport Maps">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://www.thunderforest.com/" target="blank">ThunderForest</a> contributors'
                url="https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=568fc37689cb4dc1840e9667b454437f"
              />
            </BaseLayer>
            <BaseLayer name="Topography Maps">
              <WMSTileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://www.mundialis.de/" target="blank">mundialis</a> contributors'
                url="http://ows.mundialis.de/services/service?"
                layers="TOPO-WMS,OSM-Overlay-WMS"
              />
            </BaseLayer>
          </LayersControl>
          <ZoomControl position="topright" />
          {checked ? null : <ScaleControl />}

          {latitude ? (
            <Marker position={cariCoordinat}>
              <Popup>
                Latitude : {latitude} <br /> Longitude : {longitude}
              </Popup>
            </Marker>
          ) : null}

          <GeoJSON ref={markerPendataanRefGeoJson} />
          <GeoJSON ref={kelurahanRefGeoJson} />

          {pencarian.state !== 'znt' ? (
            <div>
              <GeoJSON ref={blokRefGeoJson} />
              <GeoJSON ref={persilRefGeoJson} />
            </div>
          ) : (
            <div>
              <GeoJSON ref={zntRefGeoJson} />
            </div>
          )}

          <GeoJSON ref={markerPbbRefGeoJson} />
          <GeoJSON ref={markerBphtbRefGeoJson} />
          <GeoJSON ref={markerHotelRefGeoJson} />
          <GeoJSON ref={markerRestoranRefGeoJson} />
          <GeoJSON ref={markerHiburanRefGeoJson} />
          <GeoJSON ref={markerReklameRefGeoJson} />
          <GeoJSON ref={markerPpjRefGeoJson} />
          <GeoJSON ref={markerParkirRefGeoJson} />
          <GeoJSON ref={markerPatRefGeoJson} />
          <GeoJSON ref={markerWaletRefGeoJson} />
          <GeoJSON ref={markerMblbRefGeoJson} />
        </Map>
      </div>

      <div className={classes.center + ' leaflet-control'}>
        <Center mapRef={mapRef} state={state} />
      </div>

      <div className={classes.legend + ' leaflet-control'}>
        <Legend />
      </div>

      {checkedBphtb === true ? (
        <div className={classes.bphtb + ' leaflet-control'}>
          <LegendBphtb />
        </div>
      ) : null}

      {/*{checkedPendataan === true ? (*/}
      {/*  <div className={classes.pendataan + ' leaflet-control'}>*/}
      {/*    <LegendPendataan />*/}
      {/*  </div>*/}
      {/*) : null}*/}

      {pencarian.state === 'status_pembayaran' ? (
        <div className={classes.chart + ' leaflet-control'}>
          <Realisasi mapRef={mapRef} />
        </div>
      ) : null}

      {checkedPendataan === true ? (
        <div className={classes.chart + ' leaflet-control'}>
          <PendataanSurveyor />
        </div>
      ) : null}

      {checkedPendataan === true ? (
        <div className={classes.chart + ' leaflet-control'}>
          <PendataanKelurahan />
        </div>
      ) : null}

      {checkedPendataan === true ? (
        <div className={classes.chart + ' leaflet-control'}>
          <PendataanTarget />
        </div>
      ) : null}

      <div className={classes.search + ' leaflet-control'}>
        <SearchBrowser
          setDrawer={setDrawer}
          inputNop={inputNop}
          setInputNop={setInputNop}
          facebookProgress={facebookProgress}
          clearIcon={clearIcon}
          handleKeyPress={handleKeyPress}
          onClear={onClear}
          onSearchNop={onSearchNop}
          checked={checked}
          handleDetails={handleDetails}
          searchNop={searchNop}
          searchSppt={searchSppt}
          piutangLoading={piutangLoading}
          tahunSPPT={tahunSPPT}
          handleTahunSPPT={handleTahunSPPT}
          itemTahunSPPT={itemTahunSPPT}
          detailNop={detailNop}
          detailSppt={detailSppt}
          images={images}
          streetView={streetView}
        />
      </div>

      <div>
        <Drawer
          classes={{
            paper: classes.drawer,
          }}
          anchor={'left'}
          open={drawer}
          onClose={() => setDrawer(false)}>
          <DrawersBrowser
            drawer={drawer}
            setDrawer={setDrawer}
            mapRef={mapRef}
            getKelurahan={getKelurahan}
            getBlok={getBlok}
            getPersil={getPersil}
            getZnt={getZnt}
            markerPbbRefGeoJson={markerPbbRefGeoJson}
            getMarkerPbb={getMarkerPbb}
            markerBphtbRefGeoJson={markerBphtbRefGeoJson}
            getMarkerBphtb={getMarkerBphtb}
            markerHotelRefGeoJson={markerHotelRefGeoJson}
            getMarkerHotel={getMarkerHotel}
            markerRestoranRefGeoJson={markerRestoranRefGeoJson}
            getMarkerRestoran={getMarkerRestoran}
            markerHiburanRefGeoJson={markerHiburanRefGeoJson}
            getMarkerHiburan={getMarkerHiburan}
            markerReklameRefGeoJson={markerReklameRefGeoJson}
            getMarkerReklame={getMarkerReklame}
            markerPpjRefGeoJson={markerPpjRefGeoJson}
            getMarkerPpj={getMarkerPpj}
            markerParkirRefGeoJson={markerParkirRefGeoJson}
            getMarkerParkir={getMarkerParkir}
            markerPatRefGeoJson={markerPatRefGeoJson}
            getMarkerPat={getMarkerPat}
            markerWaletRefGeoJson={markerWaletRefGeoJson}
            getMarkerWalet={getMarkerWalet}
            markerMblbRefGeoJson={markerMblbRefGeoJson}
            getMarkerMblb={getMarkerMblb}
            markerPendataanRefGeoJson={markerPendataanRefGeoJson}
            getMarkerPendataan={getMarkerPendataan}
            setInputNop={setInputNop}
            latitude={latitude}
            setLatitude={setLatitude}
            longitude={longitude}
            setLongitude={setLongitude}
          />
        </Drawer>
      </div>

      {monografiKelurahan ? (
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={monografiKelurahan}
          onClose={handleMonografiKelurahan}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <PerfectScrollbar>
            <DialogContent style={{backgroundColor: '#efeff1'}}>
              <MonografiKelurahan
                detailMonografiKelurahan={detailMonografiKelurahan}
                setDetailMonografiKelurahan={setDetailMonografiKelurahan}
                chartMonografiKelurahan={chartMonografiKelurahan}
                setChartMonografiKelurahan={setChartMonografiKelurahan}
              />
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions style={{backgroundColor: '#efeff1'}} />
        </Dialog>
      ) : null}

      <div className={classes.loading + ' leaflet-control'}>
        <Loading />
      </div>
    </div>
  );
};

export default MapsBrowser;
